import { IISearchResultMetricDto, TooltipInfoDto } from '@/repositories/generated/apiClients';
import { Metric } from '.';

export class RawMetric implements IISearchResultMetricDto {
  constructor(
    readonly id: string,
    public tooltipInfo: TooltipInfoDto | undefined
  ) {
    this.type = 'Raw';
  }
  type: string;

  equals(d: Metric): boolean {
    return d instanceof RawMetric && d.id === this.id;
  }

  toUniqueString(): string {
    return this.id;
  }
}
